import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.85, delay, ease }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, delay = 0, className = "" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "110%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          transition={{ duration: 1.05, delay: delay + i * 0.11, ease }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const SectionLabel = ({ children, className = "" }) => (
  <Reveal className={`label ${className}`} y={12}>
    {children}
  </Reveal>
);
